/* =========================================================
   Knee theme — product page, promo bar countdown (no dependencies)
   ========================================================= */
(function () {
  'use strict';

  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));
  const pad = (n) => String(n).padStart(2, '0');

  /* ---------- Promo bar countdown ---------- */
  function timerEnd(el) {
    const mode = el.dataset.mode;
    if (mode === 'date') return Date.parse(el.dataset.end);
    if (mode === 'evergreen') {
      const key = 'kp-timer-end';
      let end = 0;
      try { end = Number(sessionStorage.getItem(key)) || 0; } catch (e) { /* storage unavailable */ }
      if (!end || end < Date.now()) {
        end = Date.now() + Number(el.dataset.minutes || 20) * 60000;
        try { sessionStorage.setItem(key, String(end)); } catch (e) { /* storage unavailable */ }
      }
      return end;
    }
    const d = new Date();
    d.setHours(24, 0, 0, 0);
    return d.getTime();
  }

  function initTimers(ctx = document) {
    $$('[data-kp-timer]', ctx).forEach((el) => {
      if (el.dataset.ready) return;
      el.dataset.ready = '1';
      let end = timerEnd(el);
      const tick = () => {
        let diff = Math.floor((end - Date.now()) / 1000);
        if (Number.isNaN(diff) || diff <= 0) {
          if (el.dataset.mode === 'date') { el.hidden = true; return; }
          end = timerEnd(el);
          diff = Math.max(0, Math.floor((end - Date.now()) / 1000));
        }
        $('[data-h]', el).textContent = pad(Math.floor(diff / 3600));
        $('[data-m]', el).textContent = pad(Math.floor((diff % 3600) / 60));
        $('[data-s]', el).textContent = pad(diff % 60);
      };
      tick();
      setInterval(tick, 1000);
    });
  }

  /* ---------- Product ---------- */
  function initProduct(root) {
    if (root.dataset.kpReady) return;
    root.dataset.kpReady = '1';
    const json = $('[data-kp-json]', root);
    if (!json) return;
    const data = JSON.parse(json.textContent);
    const variants = data.variants;

    /* Gallery */
    const track = $('[data-kp-track]', root);
    const slides = track ? $$('.kp-gallery__slide', track) : [];
    const thumbs = $$('[data-kp-thumb]', root);
    const goTo = (i) => {
      if (!track || !slides.length) return;
      const index = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[index].offsetLeft, behavior: 'smooth' });
    };
    const current = () => (track ? Math.round(track.scrollLeft / Math.max(1, track.clientWidth)) : 0);
    track && track.addEventListener('scroll', () => {
      const i = current();
      thumbs.forEach((t, n) => t.classList.toggle('is-active', n === i));
    }, { passive: true });
    thumbs.forEach((t) => t.addEventListener('click', () => goTo(Number(t.dataset.kpThumb))));
    const prev = $('[data-kp-prev]', root);
    const next = $('[data-kp-next]', root);
    prev && prev.addEventListener('click', () => goTo(current() - 1));
    next && next.addEventListener('click', () => goTo(current() + 1));
    const showMedia = (mediaId) => {
      if (!mediaId) return;
      const i = slides.findIndex((s) => Number(s.dataset.mediaId) === mediaId);
      if (i > -1) goTo(i);
    };

    /* Variant helpers */
    const findVariant = (opts) => variants.find((v) => v.options.every((o, i) => o === opts[i]));
    const pillValues = () => $$('[data-kp-option]', root).map((fs) => {
      const checked = $('input:checked', fs);
      return checked ? checked.value : null;
    });

    function syncAvailability() {
      const sel = pillValues();
      $$('[data-kp-option]', root).forEach((fs, idx) => {
        $$('input', fs).forEach((input) => {
          const test = sel.slice();
          test[idx] = input.value;
          const v = findVariant(test);
          input.closest('.kp-pill').classList.toggle('is-unavailable', !v || !v.available);
        });
      });
      const v = findVariant(sel);
      const atc = $('[data-kp-atc]', root);
      if (atc) atc.disabled = !v || !v.available;
      return v;
    }

    /* Pills set every item row of every package (each row can then be changed on its own) */
    $$('[data-kp-option] input', root).forEach((input) => input.addEventListener('change', () => {
      const sel = pillValues();
      $$('[data-kp-item-opt]', root).forEach((s) => {
        const value = sel[Number(s.dataset.kpItemOpt)];
        /* Side rows alternate: even items get the other knee */
        if (s.dataset.kpAlt === '0') {
          const other = Array.from(s.options).find((o) => o.value !== value);
          s.value = other ? other.value : value;
        } else {
          s.value = value;
        }
      });
      const v = syncAvailability();
      v && showMedia(v.media);
    }));

    /* Packages */
    const tiers = $$('[data-kp-tier]', root);
    const selectTier = (tier) => tiers.forEach((t) => t.classList.toggle('is-selected', t === tier));
    tiers.forEach((t) => $('input[type=radio]', t).addEventListener('change', () => selectTier(t)));

    function cartItems() {
      const tier = tiers.find((t) => t.classList.contains('is-selected'));
      const qty = tier ? Number(tier.dataset.qty) : 1;
      const props = tier && data.bundleProperty ? { [data.bundleProperty]: tier.dataset.title } : undefined;
      const rows = tier ? $$('[data-kp-item]', tier) : [];
      const picks = [];
      if (rows.length) {
        rows.forEach((row) => picks.push($$('[data-kp-item-opt]', row).sort((a, b) => a.dataset.kpItemOpt - b.dataset.kpItemOpt).map((s) => s.value)));
      } else {
        for (let i = 0; i < qty; i += 1) picks.push(pillValues());
      }
      const merged = new Map();
      for (const opts of picks) {
        const v = findVariant(opts);
        if (!v) return { error: 'Please choose your options.' };
        if (!v.available) return { error: `${opts.join(' / ')} is sold out.` };
        merged.set(v.id, (merged.get(v.id) || 0) + 1);
      }
      return { items: Array.from(merged, ([id, quantity]) => (props ? { id, quantity, properties: props } : { id, quantity })) };
    }

    const atc = $('[data-kp-atc]', root);
    atc && atc.addEventListener('click', async () => {
      const result = cartItems();
      if (result.error) { alert(result.error); return; }
      if (typeof window.kpAddToCart === 'function') {
        await window.kpAddToCart(result.items, atc);
      } else {
        const form = document.createElement('form');
        form.method = 'post';
        form.action = '/cart/add';
        result.items.forEach((it, i) => {
          form.insertAdjacentHTML('beforeend', `<input type="hidden" name="items[${i}][id]" value="${it.id}"><input type="hidden" name="items[${i}][quantity]" value="${it.quantity}">`);
        });
        document.body.appendChild(form);
        form.submit();
      }
    });

    /* Sizing chart */
    const chart = $('[data-kp-chart]', root);
    $('[data-kp-chart-open]', root) && $('[data-kp-chart-open]', root).addEventListener('click', () => chart && chart.showModal());
    $('[data-kp-chart-close]', root) && $('[data-kp-chart-close]', root).addEventListener('click', () => chart && chart.close());
    chart && chart.addEventListener('click', (e) => { if (e.target === chart) chart.close(); });

    /* Sticky bar: visible once the main button has scrolled out of view */
    const sticky = $('[data-kp-sticky]', root);
    if (sticky && atc && 'IntersectionObserver' in window) {
      new IntersectionObserver(([entry]) => {
        const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      }).observe(atc);
      $('[data-kp-sticky-btn]', sticky).addEventListener('click', () => {
        const box = $('[data-kp-bundles]', root) || atc;
        box.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }

    syncAvailability();
  }

  function init(ctx = document) {
    initTimers(ctx);
    $$('[data-kp-product]', ctx).forEach(initProduct);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
